export default __webpack_public_path__ + "static/media/Pankhuri.58cdf819.jpeg";